<template>
	<div>
		<el-page-header @back="goBack" content="脸谱详情设置"></el-page-header>
		<div class="topic-outer">
			<div class="appraisal-center fonts">
				<div class="pub-line">
					<span>分类：</span>
					<span class="glay"
						>{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
					>
				</div>
				<div class="flex-box pub-line">
					<div class="fl1">
						<span>名称：</span>
						<span class="glay">{{ detalisObj.name }}</span>
					</div>
					<div class="fl1">
						<span> 标识：</span>
						<span class="glay">{{ detalisObj.examId }}</span>
					</div>
				</div>

				<div class="flex-box pub-line">
					<div class="fl1">
						<span>解析：</span>
						<span class="glay">{{ detalisObj.schemeName }}</span>
					</div>
					<div class="fl1">
						<span> 题目：</span>
						<span class="glay"
							>共 <i>{{ detalisObj.questions }}</i
							>题</span
						>
					</div>
				</div>
			</div>
		</div>
		<div class="second_tops" v-loading="loading">
			<div style="min-height: 56vh">
				<template v-if="initJZData && initJZData.length">
					<el-tabs
						tab-position="left"
						v-model="activeName"
						@tab-click="handTabClick"
					>
						<el-tab-pane
							v-for="item in initJZData"
							:key="item.examDimensionId"
							:label="item.name"
							:name="item.examDimensionId.toString()"
						>
						</el-tab-pane>
						<el-tag
							style="margin-bottom: 12px"
							effect="plain"
							@click="handleDimensionEdit"
						>
							{{ dimensionInfo.name }}
							<i class="el-icon-edit"></i>
						</el-tag>
						<div
							style="margin-bottom: 12px"
							v-for="item in dimensionInfo.childrens"
							:key="item.code"
						>
							{{ item.name }}：
							<el-tag
								effect="plain"
								class="tag-marr"
								:class="{ activeBg1: datumId == item.code }"
								@click="activeEvent(item)"
								:key="index"
								size="medium"
								v-for="(item, index) in item.childrens"
								type="danger"
								style="padding: 0 24px"
							>
								{{ item.name }}
							</el-tag>
						</div>
						<div>
							<div class="public-dialog-form">
								<el-form ref="ruleForm" :model="params" label-width="110px">
									<el-row>
										<el-tabs
											type="card"
											v-model="languageCode"
											@tab-click="handleTabClick('question')"
										>
											<el-tab-pane
												v-for="(item, index) in languageList"
												:label="item.name"
												:name="item.code"
												:key="index"
											></el-tab-pane>
										</el-tabs>
									</el-row>
									<el-row>
										<el-col :span="8">
											<el-form-item label="图片">
												<div class="diplay" style="margin-right: 10px">
													<div class="screenshot">
														<span
															v-for="(imgUrl, index) in srcList"
															:key="index"
															class="slideshow"
														>
															<el-image
																style="
																	width: 100px;
																	height: 100px;
																	border-radius: 6px;
																"
																:src="imgUrl"
																fit="cover"
																@click="getPolicy"
															/>
														</span>
														<div
															class="up-btn"
															style="
																width: 100px;
																height: 100px;
																line-height: 100px;
															"
															@click="getPolicy"
															v-if="isMoer"
														>
															<i class="el-icon-plus"></i>
														</div>
													</div>
													<input
														type="file"
														ref="file"
														@change="getFile"
														accept="image/png,image/jpg"
													/>
												</div>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row type="flex">
										<el-col :span="12">
											<el-form-item label="名称" prop="name">
												<el-input
													placeholder="请输入名称"
													v-model="params.name"
													style="width: 262px"
												></el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<template v-for="(item, index) in getEditFormConfig">
										<el-form-item
											:key="index"
											:label="getEditFormConfig[index].label"
											:prop="getEditFormConfig[index].name"
										>
											<component
												v-if="
													getEditFormConfig[index].show ? innerVisible : true
												"
												:is="getEditFormConfig[index].el"
												v-model="params[getEditFormConfig[index].name]"
												v-bind="getEditFormConfig[index].attrs"
												:params="params ? params : ''"
											/>
										</el-form-item>
									</template>
								</el-form>
								<span slot="footer" class="public-dialog-footer">
									<el-button size="medium" @click="handleContentEdit('reset')">
										重 置</el-button
									>
									<el-button
										size="medium"
										type="primary"
										@click="handleContentEdit('add')"
										>提 交</el-button
									>
								</span>
							</div>
						</div>
					</el-tabs>
				</template>
			</div>
		</div>
		<!-- 编辑 -->
		<el-dialog
			title="编辑"
			:visible.sync="dialogVisible"
			width="460px"
			:close-on-click-modal="false"
		>
			<div>
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="dimensionDetails"
					label-width="80px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick('dimension')"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-form-item label="名称" prop="name">
						<el-input
							placeholder="请填写名称"
							v-model="dimensionDetails.name"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { emptyShow, isEmpty } from "@utils/tools";
import richText from "@comp/richText";
import { ossUpload } from "@utils/filters/upload";
import { getEditFormConfig } from "./tzfgRgSet.js";

export default {
	name: "mjywlList",
	components: {
		richText,
	},
	data() {
		return {
			getEditFormConfig,
			emptyShow,
			isEmpty,
			detalisObj: {},
			loading: false,
			initJZData: [],
			languageList: [],
			activeName: "",
			params: {},
			innerVisible: false,
			srcList: [],
			isMoer: true,
			languageCode: "",
			dialogVisible: false,
			datumId: "",
			dimensionInfo: {},
			dimensionDetails: {},
			rules: {
				name: [{ required: true, message: "请填写名称", trigger: "change" }],
			},
		};
	},
	watch: {},
	mounted() {
		this.getLanguageList();
		this.getAppraisalData();
		this.initJZ();
	},
	methods: {
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		/**
		 * 编辑维度/基准
		 */
		async handleDimensionEdit() {
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/dimension/info/${this.$route.query.examId}/${this.dimensionInfo.code}`,
				{
					headers: {
						"Language-Code": this.languageCode,
					},
				}
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.dimensionDetails = resData.data;
			this.dialogVisible = true;
		},
		/**
		 * 维度/基准数据保存
		 */
		handleEdit() {
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					this.dimensionDetails.examId = this.$route.query.examId;
					const { data: resData } = await this.$post(
						"exam/dimension/info",
						this.dimensionDetails,
						{
							headers: {
								isLoading: true,
								"Language-Code": this.languageCode,
							},
						}
					);
					if (resData.result != 200) return;
					// this.dialogVisible = false;
					this.$message.success("操作成功!");
					// this.getDimensionList();
					this.resultDetails(this.params.examDimensionId);
					this.handleDimensionEdit();
					this.srcList = [];
				});
			});
		},
		handleTabClick(e) {
			if (e == "question") {
				return this.resultDetails(this.activeName);
			}
			if (e == "dimension") {
				this.handleDimensionEdit();
				this.resultDetails(this.activeName);
			}
		},
		handTabClick(data) {
			this.innerVisible = false;
			this.srcList = [];
			this.isMoer = true;
			this.params = {};
			this.dimensionInfo = this.initJZData[data.index];
			this.params.examDimensionId = parseInt(data.name);
			this.datumId = this.dimensionInfo.childrens[0].childrens[0].code;
			this.resultDetails(data.name);
		},
		/**
		 * 维度切换
		 */
		activeEvent(item) {
			this.datumId = item.code;
			this.datumInfo = item;
			this.resultDetails(item.examDimensionId);
		},
		/**
		 * 初始化基准
		 */
		async initJZ() {
			this.loading = true;
			const { data: resData } = await this.$get(`exam/dimension/list`, {
				params: {
					examId: this.$route.query.examId,
					parentId: -1,
					tree: true,
				},
				headers: {
					"Language-Code": "CN",
				},
			});
			if (resData.result != 200) {
				this.loading = false;
				return;
			}
			if (resData.data) {
				this.loading = false;
				this.initJZData = resData.data;
				this.dimensionInfo = resData.data[0];
				this.activeName = resData.data[0].examDimensionId.toString();
				this.params.examDimensionId = resData.data[0].examDimensionId;

				this.datumId = resData.data[0].childrens[0].childrens[0].code;
				this.resultDetails(
					resData.data[0].childrens[0].childrens[0].examDimensionId
				);
			} else {
				this.initJZData = [];
				this.loading = false;
			}
		},
		async resultDetails(examDimensionId) {
			this.innerVisible = false;
			const { data: resData } = await this.$get(`exam/result/list`, {
				params: {
					examId: this.$route.query.examId,
					examDimensionCode: this.datumId,
				},
				headers: {
					isLoading: true,
					"Language-Code": this.languageCode,
				},
			});
			if (resData.result != 200) return;
			this.srcList = [];
			this.isMoer = true;
			if (resData.data) {
				if (resData.data[0].icon) {
					this.srcList.push(resData.data[0].icon);
					this.isMoer = false;
				}
				this.params = resData.data[0];
				console.log("🚀 ~   ~ resultDetails ~ this.params:", this.params);
				this.innerVisible = true;
			} else {
				this.params = {};
				this.innerVisible = true;
			}
		},
		handleContentEdit(type) {
			if (type == "add") {
				this.$refs.ruleForm.validate((valid) => {
					if (!valid) return;
					this.$confirm("确认保存数据, 是否继续?", "提示", {
						type: "info",
					}).then(async () => {
						const examResultId = this.params.examResultId;
						const api = examResultId ? this.$put : this.$post;
						const { data: resData } = await api(
							"exam/result/info",
							{
								...this.params,
								examId: this.$route.query.examId,
								examDimensionCode: this.datumId,
							},
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.$message.success("提交成功!");
					});
				});
			} else if (type == "reset") {
				this.$confirm("确认重置当前数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					const { data: resData } = await this.$post(
						"exam/result/init/datum/" + this.$route.query.examId,
						{
							headers: {
								isLoading: true,
								"Language-Code": this.languageCode,
							},
						}
					);
					this.$message.success("重置成功!");
				});
			}
		},
		/**
		 * 获取测评详情
		 */
		async getAppraisalData() {
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/info/${this.$route.query.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.detalisObj = resData.data;
		},
		/**
		 * 返回
		 */
		goBack() {
			this.$router.back();
		},
		getPolicy() {
			this.$refs.file.dispatchEvent(new MouseEvent("click"));
		},
		async getFile() {
			const that = this;
			const { data: resData } = await this.$get("/aliyun/oss/sign", {
				headers: {
					isLoading: true,
					"Language-Code": this.languageCode,
				},
			});
			if (resData.result != 200) return;
			const addRoutes = await ossUpload(
				that.$refs.file.files[0],
				resData.data,
				"one", //'more','one'
				this.srcList
			);
			this.isMoer = false;
			this.srcList = addRoutes;
			this.params.icon = this.srcList[0];
		},
	},
};
</script>

<style scoped lang="scss">
.appraisal-center {
	width: 90%;
	margin: 0 auto;
}

.fonts {
	font-size: 14px;
}

.topic-outer {
	width: 100%;
	background: #fff;
	overflow: hidden;
	margin-top: 20px;
	padding-bottom: 30px;
}

.flex-box {
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
}

.fl1 {
	flex: 1;
	-webkit-flex: 1;
}

.glay {
	color: #8492a6;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.pub-line {
	margin-top: 30px;
}

.marr {
	margin-top: 20px;
}

.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}
.second_tops {
	padding-top: 20px;
	box-sizing: border-box;
}
.public-dialog-form {
	height: 55vh;
	overflow-y: scroll;
}
.activeBg1 {
	background: #fbc4c4;
	color: #fff;
}
</style>
<style>
.second_tops .el-tabs__item {
	white-space: pre-wrap;
	text-align: left !important;
	line-height: 46px;
	max-width: 300px;
	height: 46px !important;
}
</style>
